import React, { FC, useState } from 'react'
import { Button, Icon, IconName } from '@resurs/midas-react'
import { useLocation } from 'react-router'
import { getText } from '../../../app/internal/TextLabels'

import styles from './ModuleLoadError.module.scss'

export const ModuleLoadError: FC<{
  name: string
  updateInProgress: boolean
  forceReload: boolean
}> = ({ name, updateInProgress, forceReload }) => {
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const params = new URLSearchParams(location.search)

  if (forceReload) {
    if (!params.has('reload')) {
      params.set('reload', Date.now().toString())
      window.history.pushState(
        {},
        '',
        `${window.location.pathname}?${params.toString()}`,
      )
      window.location.reload()
    }
    return null
  }

  const dialogData: Record<
    string,
    {
      icon: IconName
      title: string
      message: string
      message2: string
    }
  > = {
    true: {
      icon: 'midasSettingGear',
      title: getText('modules.updateInProgress.title'),
      message: getText('modules.updateInProgress.msg1', {
        moduleName: getText(`modules.${name}`),
      }),
      message2: getText('modules.updateInProgress.msg2'),
    },
    false: {
      icon: 'midasBubbleAttention6',
      title: getText('modules.failedToLoadModule.title'),
      message: getText('modules.failedToLoadModule.msg1', {
        moduleName: getText(`modules.${name}`),
      }),
      message2: getText('modules.failedToLoadModule.msg2'),
    },
  }

  const data = dialogData[`${!updateInProgress}`]

  return (
    <div className={styles.ModuleLoadError}>
      <div className={styles.centeredDiv}>
        <div className={styles.red}>
          <Icon large name={data.icon} />
        </div>
        <div>
          <h4>{data.title}</h4>
          <p>{data.message}</p>
          <br />
          <p>{data.message2}</p>
          <div className={styles.reloadButton}>
            <Button
              type="normal"
              onClick={e => {
                setLoading(true)
                window.location.reload()
                e.preventDefault()
                e.stopPropagation()
              }}
              loading={loading}
            >
              {getText('default.reloadPage')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModuleLoadError
